export enum InsuranceOutcomeTypesEnum {
  Covered = 'Covered, No PA Needed',
  NotCovered = 'Not Covered, PA Needed',
  NoCoverage = 'No Active Coverage',
}
